exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-notas-de-estudo-js": () => import("./../../../src/pages/notas-de-estudo.js" /* webpackChunkName: "component---src-pages-notas-de-estudo-js" */),
  "component---src-templates-nota-js": () => import("./../../../src/templates/nota.js" /* webpackChunkName: "component---src-templates-nota-js" */)
}

